import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {BemSubtiposFormComponent} from "./bem-subtipos-form/bem-subtipos-form.component";
import {BemSubtipoApiService} from "./shared/bem-subtipo-api.service";
import {BemSubtiposListComponent} from "./bem-subtipos-list/bem-subtipos-list.component";

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    BemSubtipoApiService
  ],
  declarations: [
    BemSubtiposListComponent,
    BemSubtiposFormComponent
  ],
  exports: [
    BemSubtiposFormComponent,
    BemSubtiposListComponent
  ]
})
export class BemSubtiposModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-subtipos/bem-subtipos.module.ts
 **/